import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModulLocatieActiva, ModulLocatieActivaUpdate } from './module-locatii.interface';

@Injectable({
    providedIn: 'root'
})
export class ModuleLocatiiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getModuleLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.getModuleLocatii;
    private storeModulLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.storeModulLocatii;
    private updateModulLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.updateModulLocatii;
    private deleteModulLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.deleteModulLocatii;
    private moveUpUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.moveUp;
    private moveDownUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiActive.moveDown;

    constructor(private http: HttpClient) { }

    addModulLocatii(modulLocatie: ModulLocatieActiva) {
        return this.http.post(this.storeModulLocatiiUrl, modulLocatie, this.httpOptions);
    }

    updateModulLocatii(modulLocatie: ModulLocatieActivaUpdate) {
        return this.http.put(this.updateModulLocatiiUrl, modulLocatie, this.httpOptions);
    }

    deleteModulLocatii(id: number) {
        return this.http.delete(this.deleteModulLocatiiUrl + id);
    }

    getModuleLocatii() {
        return this.http.get(this.getModuleLocatiiUrl, this.httpOptions);
    }

    moveUp(id: number) {
        return this.http.put(this.moveUpUrl + id, this.httpOptions);
    }

    moveDown(id: number) {
        return this.http.put(this.moveDownUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
